import React, { useContext, useEffect, useState } from "react";
//Import Context
import { AppContext } from "../../../contexts/AppContext";
//Import Helpers
import { formatCurrency, formatDate, formatDisplayName, getSubventionNames } from "../../../shared/helpers";
//Import Components
import PrintPurchaseFormButton from "./PrintPurchaseFormButton";
//Import CSS
import './viewPurchaseRequestForm.css';

function ViewPurchaseRequestForm({ onClose, requestDetails, establishmentList, fromRequestTracking, fromViewPayment, fromViewRequest, typeOfRequest, fromPreview }) {
    const { pmeList, requestsList } = useContext(AppContext);
    const { request, activity } = requestDetails;
    const [isVisible, setIsVisible] = useState(false);

    //Effects
    useEffect(() => {
        const contenedor = document.querySelector('.view-request'); // o tu clase principal scrollable
        if (contenedor) contenedor.scrollTop = 0;
    }, []);

    useEffect(() => {
        // Activar la animación después de que el componente se monte
        setTimeout(() => setIsVisible(true), 50);
    }, []);

    const handleClose = () => {
        setIsVisible(false);
        // Esperar a que termine la animación antes de cerrar
        setTimeout(onClose, 300);
    };

    const getEstablishment = () => {
        return establishmentList.find(establishment => establishment.id === request?.idEstablishment);
    };

    const getPME = () => {
        return pmeList.find(pme => pme.id === request?.idPME);
    };

    const getRequestOrigin = () => {
        if (request?.typeOfRequest === 'payment') {
            const originalRequest = requestsList.find(req => req.id === request.originRequestId);
            return originalRequest;
        }
    };

    const typeOfRequestOk = typeOfRequest || request.typeOfRequest;
    console.log(request);

    return (
        <section className={`view-purchase-request-container flex ${isVisible ? 'show' : ''} ${fromRequestTracking ? 'request-tracking' : ''} ${fromViewPayment ? 'payment' : ''} ${fromViewRequest ? 'view-request' : ''} ${fromPreview ? 'preview' : ''}`}>
            <header className='header-view-purchase-request flex'>
                <h3>{typeOfRequestOk === 'purchase'
                    ? 'Formulario Solicitud de Compra'
                    : 'Formulario Solicitud Contrato de Servicio'}
                </h3>
                <span className='header-actions flex'>
                    <PrintPurchaseFormButton typeOfRequest={typeOfRequestOk} />
                    <button className='button-close' onClick={handleClose}><p>Volver</p></button>
                </span>
            </header>
            <article className='info-request flex'>
                <table className='table-info-request'>
                    <thead>
                        <tr>
                            <th>Folio Solicitud</th>
                            <th>Fecha Solicitud</th>
                            <th>Establecimiento</th>
                            <th>RBD</th>
                            <th>Año de Gasto PME</th>
                            <th>Tipo de Subvención</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{request.requestDetails?.folio}</td>
                            <td>{formatDate(request?.typeOfRequest === 'payment' ? request?.created : request?.requestDetails.created)}</td>
                            <td>{getEstablishment()?.nameEstablishment}</td>
                            <td>{getEstablishment()?.rbd}</td>
                            <td>{getPME()?.yearPME}</td>
                            <td>{getSubventionNames(activity?.subsidies)}</td>
                        </tr>
                    </tbody>
                </table>
            </article>
            <article className='description-action flex'>
                <p className='subtitle'>Detalles de la Actividad</p>
                <span className='description-action-box flex'>
                    <table>
                        <thead>
                            <tr>
                                <th>Dimensión</th>
                                <th>Nombre Acción</th>
                                <th>Clasificación</th>
                                <th>Cuenta SUPEREDUC</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDisplayName(activity?.dimension)}</td>
                                <td>{formatDisplayName(activity?.nameOfAction)}</td>
                                <td>{formatDisplayName(activity?.clasificationOfAction)}</td>
                                <td>{request.typeOfRequest === 'payment'
                                    ? getRequestOrigin().requestDetails.supereducAccount ? formatDisplayName(getRequestOrigin().requestDetails?.supereducAccount) : 'No ingresado'
                                    : request.requestDetails.supereducAccount ? formatDisplayName(request.requestDetails?.supereducAccount) : 'No ingresado'
                                }
                                </td>
                                {/* <td>{request.requestDetails.supereducAccount ? formatDisplayName(request.requestDetails?.supereducAccount) : 'No ingresado'}</td> */}
                            </tr>
                        </tbody>
                    </table>
                </span>
            </article>
            <article className='additional-info flex'>
                <p className='subtitle'>Detalles Solicitud</p>
                <span className='additional-info-box flex'>
                    <table>
                        <thead>
                            <tr>
                                <th>Responsable</th>
                                <th>Teléfono</th>
                                <th>Cargo Responsable</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{formatDisplayName(request.requestDetails?.responsibleName)}</td>
                                <td>{request.requestDetails?.responsiblePhone ? request.requestDetails?.responsiblePhone : 'N/A'}</td>
                                <td>{formatDisplayName(request.requestDetails?.responsiblePosition)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <span className='flex'>
                        <p>Observaciones:</p>
                        <p>{request.requestDetails?.observations ? formatDisplayName(request.requestDetails?.observations) : 'No tiene Observaciones'}</p>
                    </span>
                    <span className='flex'>
                        <p>Justificación técnica:</p>
                        <p>{request.requestDetails?.technicalJustification ? formatDisplayName(request.requestDetails?.technicalJustification) : 'No tiene Justificación Técnica'}</p>
                    </span>
                </span>
            </article>
            <article className='purchase-details flex'>
                <p className='subtitle'>Detalle de Compra</p>
                <table>
                    <thead>
                        <tr>
                            <th>Item</th>
                            <th>Detalle</th>
                            <th>Cantidad</th>
                            <th>Valor Unitario</th>
                            <th>Valor Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        {request.typeOfRequest === 'payment' ? (
                            getRequestOrigin()?.requestDetails?.shoppingItems?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{formatDisplayName(item.detail)}</td>
                                    <td>{item.quantity}</td>
                                    <td>{formatCurrency(item.unitValue)}</td>
                                    <td>{formatCurrency(item.totalValue)}</td>
                                </tr>
                            ))
                        ) : (
                            request.requestDetails?.shoppingItems?.map((item, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{formatDisplayName(item.detail)}</td>
                                    <td>{item.quantity}</td>
                                    <td>{formatCurrency(item.unitValue)}</td>
                                    <td>{formatCurrency(item.totalValue)}</td>
                                </tr>
                            )))
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan='4'> Total</td>
                            <td>{request.typeOfRequest === 'payment' ? (formatCurrency(getRequestOrigin().requestDetails?.requestAmount)) : (formatCurrency(request.requestDetails?.requestAmount))}</td>
                        </tr>
                    </tfoot>
                </table>
            </article>
            <article className='attachments flex'>
                <p className='subtitle'>Archivos Adjuntos</p>
                <span className='official-docs flex'>
                    <p>Ordinario:</p>
                    <ul className='flex'>
                        {(request.typeOfRequest === 'payment'
                            ? getRequestOrigin().requestDetails.attachments?.officialDocs || []
                            : request.requestDetails.attachments?.officialDocs || []
                        ).map((doc, index) => (
                            <li key={index}>
                                <a href={doc.fileUrl} target="_blank" rel="noopener noreferrer">
                                    {doc.fileName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </span>
                <span className='backups flex'>
                    <p>Respaldos:</p>
                    <ul className='flex'>
                        {(request.typeOfRequest === 'payment'
                            ? getRequestOrigin().requestDetails.attachments?.backups || []
                            : request.requestDetails.attachments?.backups || []
                        ).map((doc, index) => (
                            <li key={index}>
                                <a href={doc.fileUrl} target="_blank" rel="noopener noreferrer">
                                    {doc.fileName}
                                </a>
                            </li>
                        ))}
                    </ul>
                </span>
            </article>
        </section>
    );
};

export default ViewPurchaseRequestForm;